export default __webpack_public_path__ + "static/media/köide-33ЛАСТ.d53ab53e.png";